import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { PractitionRole } from '../_models/practition-role.model';
import { QueryParamsModel } from '../../_base/crud';

export enum PractitionRoleActionTypes {
  AllPractitionRolesRequested = '[PractitionRoles Module] All PractitionRoles Requested',
  AllPractitionRolesLoaded = '[PractitionRoles API] All PractitionRoles Loaded',
  PractitionRoleOnServerCreated = '[Edit PractitionRole Component] PractitionRole On Server Created',
  PractitionRoleCreated = '[Edit PractitionRole Dialog] PractitionRole Created',
  PractitionRoleOnServerUpdated = '[Edit PractitionRole Dialog] PractitionRole On Server Updated',
  PractitionRoleUpdated = '[Edit PractitionRole Dialog] PractitionRole Updated',
  PractitionRoleStatusOnServerUpdated = '[PractitionRoles List Page] PractitionRole Status On Server Updated Updated',
  PractitionRoleStatusUpdated = '[PractitionRoles List Page] PractitionRole Status Updated Updated',
  PractitionRolesStatusOnServerUpdated = '[PractitionRoles List Page] PractitionRoles Status On Server Updated Updated',
  PractitionRolesStatusUpdated = '[PractitionRoles List Page] PractitionRoles Status Updated Updated',
  PractitionRoleOnServerDeleted = '[PractitionRoles List Page] PractitionRole On Server Deleted',
  PractitionRoleDeleted = '[PractitionRoles List Page] PractitionRole Deleted',
  ManyPractitionRolesOnServerDeleted = '[PractitionRoles List Page] PractitionRoles On Server Deleted',
  ManyPractitionRolesDeleted = '[PractitionRoles List Page] PractitionRoles Deleted',
  PractitionRolesPageRequested = '[PractitionRoles List Page] PractitionRoles Page Requested',
  PractitionRolesPageLoaded = '[PractitionRoles API] PractitionRoles Page Loaded',
  PractitionRolesPageCancelled = '[PractitionRoles API] PractitionRoles Page Cancelled',
  PractitionRolesPageToggleLoading = '[PractitionRoles] PractitionRoles Page Toggle Loading',
  PractitionRolesActionToggleLoading = '[PractitionRoles] PractitionRoles Action Toggle Loading',
  ThrowPractitionRoleError = '[PractitionRoles] ThrowPractitionRoleError',
  ClearPractitionRoleErrors = '[PractitionRoles] ClearPractitionRoleErrors',
}

export class PractitionRoleOnServerCreated implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleOnServerCreated;

  constructor(public payload: { practitionRole: PractitionRole }) {}
}

export class PractitionRoleCreated implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleCreated;

  constructor(public payload: { practitionRole: PractitionRole }) {}
}

export class ThrowPractitionRoleError implements Action {
  readonly type = PractitionRoleActionTypes.ThrowPractitionRoleError;

  constructor(public payload: { error: any }) {}
}

export class ClearPractitionRoleErrors implements Action {
  readonly type = PractitionRoleActionTypes.ClearPractitionRoleErrors;
}

export class PractitionRoleOnServerUpdated implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleOnServerUpdated;

  constructor(
    public payload: {
      partialPractitionRole: Update<PractitionRole>;
      practitionRole: PractitionRole;
    },
  ) {}
}

export class PractitionRoleUpdated implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleUpdated;

  constructor(
    public payload: {
      partialPractitionRole: Update<PractitionRole>;
      practitionRole: PractitionRole;
    },
  ) {}
}

export class PractitionRoleStatusOnServerUpdated implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleStatusOnServerUpdated;

  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class PractitionRoleStatusUpdated implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleStatusUpdated;

  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class PractitionRoleOnServerDeleted implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class PractitionRoleDeleted implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRoleDeleted;

  constructor(public payload: { id: number }) {}
}

export class PractitionRolesPageRequested implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRolesPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class PractitionRolesPageLoaded implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRolesPageLoaded;
  constructor(
    public payload: {
      practitionRoles: PractitionRole[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class PractitionRolesPageCancelled implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRolesPageCancelled;
}

export class PractitionRolesPageToggleLoading implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRolesPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class PractitionRolesActionToggleLoading implements Action {
  readonly type = PractitionRoleActionTypes.PractitionRolesActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type PractitionRoleActions =
  | PractitionRoleCreated
  | PractitionRoleUpdated
  | PractitionRoleDeleted
  | PractitionRoleOnServerCreated
  | PractitionRoleOnServerUpdated
  | PractitionRoleOnServerDeleted
  | PractitionRoleStatusOnServerUpdated
  | PractitionRolesPageLoaded
  | PractitionRolesPageCancelled
  | PractitionRolesPageToggleLoading
  | PractitionRolesPageRequested
  | PractitionRoleStatusUpdated
  | ThrowPractitionRoleError
  | ClearPractitionRoleErrors
  | PractitionRolesActionToggleLoading;
